import { Guardian, GuardianQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

export const useGuardianQuery = (guardianId: number): UseCqrsQueryResult<Guardian> => {
   return useCqrsGet(() => {
      const guardianQuery = new GuardianQuery();
      guardianQuery.id = Slot.of(guardianId);
      return guardianQuery;
   });
};
